import { Button } from 'antd';
import { Business } from '../../../../../store/business';

import styles from '../index.module.scss';
import { IconArrow, IconInformation } from '../../../../Common/Icon';
import { useRevokeBusinessOwnership } from './useRevokeBusinessOwnership';
import { useNavigate } from 'react-router-dom';

interface BusinessItemProps {
  business: Business;
}

const BusinessItem = ({ business }: BusinessItemProps) => {
  const navigate = useNavigate();
  const { revokeBusinessOwnership, loading } = useRevokeBusinessOwnership(
    business.id
  );

  return (
    <div key={business.id} className={styles.item}>
      <div className={styles.content}>
        <div>
          <div style={{ fontWeight: 600, fontSize: 16 }}>{business.name}</div>
          <div style={{ color: '#777' }}>{business.address}</div>
        </div>
        <div>
          <Button
            size="large"
            type="link"
            className={styles.claimInerLink}
            loading={loading}
            onClick={revokeBusinessOwnership}
          >
            Unclaim Business
          </Button>
          <Button
            size="large"
            type="default"
            className={styles.claimInerBtn}
            icon={<IconArrow />}
            onClick={() => navigate(`/business/${business.id}`)}
          >
            View Page
          </Button>
        </div>
      </div>
      {business.status === 'draft' && (
        <div className={styles.alert}>
          <IconInformation />
          <span>
            This business has no posts yet. Be the first one to write about it
            and engage with the community
          </span>
        </div>
      )}
    </div>
  );
};

export default BusinessItem;
